import { IntervalPayload, SubmitReportPayload } from 'api/report/types';
import { IntervalEntryValidations, IntervalReportDraft } from './editing';

export function buildIntervalPayload(
    reportTemplateID: number,
    draft: IntervalReportDraft,
    entryValidation: IntervalEntryValidations
): (SubmitReportPayload & { data: IntervalPayload }) | null {
    const entries: IntervalPayload['entries'] = [];
    for (const day of draft.days) {
        for (const entry of day.entries) {
            const validation = entryValidation[entry.uuid];
            if (!validation || Object.keys(validation.errors).length > 0) {
                return null;
            }
            entries.push({
                kind: entry.kind,
                isSick: entry.isSick,
                reportingDate: day.date,
                startAt: entry.startAt,
                endAt: entry.endAt,
                breakMinutes: Number(entry.breakMinutes),
                locationUUID: entry.location?.uuid ?? null,
                reasonUUID: entry.reason?.uuid ?? null,
                distanceKm:
                    entry.distanceKm.trim() === ''
                        ? null
                        : Number(entry.distanceKm),
                note: entry.note,
            });
        }
    }
    return {
        reportTemplateID,
        data: { entries, notes: draft.notes },
    };
}
